export const checkExpireTime = (expiresIn:string, idleSeconds?:number) => {
    try {
        idleSeconds = idleSeconds || 300;

        const cTime = new Date();
        const expireTime = new Date(expiresIn);
        const limit = new Date(expireTime.getTime() - idleSeconds * 1000);


        return limit > cTime;
    } catch (e) {
        console.error(e);
        return false;
    }
}

export default checkExpireTime;